// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"30f339e4","453":"cddcc98d","455":"86c507fb","644":"df17858b"}[chunkId] + ".chunk.js";
};